<template>
<div>
  <loading v-if="isloading"></loading>
  <div v-else class="container detail-container">
    <list-item :id="typeId" from="detail" :index="0"  :trdata="data" @showTip="showTip"></list-item>

    
    <div class="comments-view">
      <div class="commets-header">
        回复（ {{data.comment_count}} ）
        <button class="btn" @click.prevent="goRoute"><i class="sprite sprite-xie"></i>写评论</button>
        <!-- <router-link :to="'/comment/' + data.id + '?typeId=' + typeId " class="btn"><i class="iconfont icon-xie"></i>写评论</router-link :to=""> -->
      </div>
      <div v-if="!data.comment_count" class="no-data">
        <router-link :to="'/comment/' + data.id + '?typeId=' + typeId">
          <img class="blank" src="~assets/imgs/blank.png"></img>
          <p>竟然还没有评论呐！占领它！</p>
        </router-link>
      </div>
      <comments-list v-if="comments.length" :comments="comments" :contentId="id"></comments-list>
    </div>
    <modal v-show="tip" ref="tip" :download="download" :content="tip"></modal>
  </div>
</div>
</template>
<script>
  import ListItem from 'components/list/ListItem.vue';
  import CommentsList from 'components/comments/CommentsList.vue';
  import Modal from 'components/tips/Modal.vue';
  import Loading from 'components/tips/Loading.vue';
 
  import {getDetail, getComments,getProfile } from 'assets/js/community.js';
  export default {
    name: 'Detail',
    data(){
      return {
        typeId: 2,
        data: '',
        comments: [],
        tip: '',
        download: true,
        isloading: true
      }
    },
    components: {
      ListItem,
      CommentsList,
      Modal,
      Loading
    },
    computed:{
      user(){
        return this.$store.state.user;
      },
      tokens(){
        return this.$store.state.tokens;
      }
    },
    beforeCreate(){
      console.log('detail:', this.$route.params, this.$route.query);
      this.typeId = this.$route.query.typeId;
      this.id = this.$route.params.id; 
    },
    created(){
      this.loadData();
    },
    methods: {
      cbgcAuth(){
        this.$store.dispatch('cbgcAuth', {
          cacheName: 'cbgcAuth',
          refresh: 1
        }).then(res=>{
          // console.log('view auth res:', res);
        });
      },
      async loadData(type){
        let tokens = this.tokens || await this.$store.dispatch('cbgcAuth');
        if(tokens.status){
          this.$emit('showTip', tokens.message);
          return;
        }
        tokens = typeof tokens == 'string' ? tokens : tokens.access_token;
        switch(type){
          case 'comment':
            getComments(this.id, tokens).then(res=>{
              // console.log('comments res:' ,res);
              this.comments = res.data.data;
              this.commentsPagination = res.data.meta.pagination;
            });
          break;
          default:
            
            
            getDetail(this.id, tokens).then(res=>{
              getProfile(res.data[0].user.id, tokens).then(profile=>{
                res.data[0].followed = profile.data.followed;
                this.data = res.data[0];
                let content = this.data.content;
                if(/content/.test(content)){
                  content = JSON.parse(this.data.content);
                  content = content.content;
                }
                if(/<\/a>/.test(content)){
                  content = content.replace(/(<\/?a.*?>)/g, '');
                }
                content = content.substr(0, 16);
                document.title = content;
                this.isloading = false;
                this.data.comment_count && this.loadData('comment');
              });
              
            });
          break;
        }
      },
      showTip(tip){
        this.tip = tip;
        this.$refs.tip.taggle(true);
      },
      async goRoute(){
        let tokens = this.tokens || await this.$store.dispatch('cbgcAuth', {
          cacheName: 'cbgcAuth',
          refresh: 1
        });
        if(tokens.status){
          this.showTip(tokens.message);
          return;
        }
        this.$router.push({
          name: 'Comment',
          params: {
            id: this.id
          },
          query:{
            typeId: this.typeId
          }
        });
      }
    }
  }
</script>
<style lang="scss">
  .detail-container{
    
    .item{
      padding: 3.33vw 3.33vw 3vw;
      margin-bottom: .5em;
      background-color: #fff;
    }
  }
  .comments-view{
    padding: 0 1em 1em;
  }
  .commets-header{
    border-bottom: 1px solid #eee;
    padding-bottom: .5em;
    margin-bottom: .5em;
    position: relative;
    line-height: 2.4;
    .btn{
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  
</style>